function buildTaskShareMessage(task = {}, taskUrl = "") {
    const taskLabel = [task.TaskKey, task.TaskName || task.taskName]
        .filter(Boolean)
        .join(" — ");

    return {
        type: "link",
        message: `${taskLabel || "Công việc"}\n${taskUrl}`,
    };
}

function parseTaskShareMessage(message = "") {
    const [taskLabel, taskUrl] = String(message).split(/\r?\n/);
    const separatorIndex = taskLabel?.indexOf(" — ") ?? -1;

    if (separatorIndex < 1 || !taskUrl) return null;

    let parsedUrl;
    try {
        parsedUrl = new URL(taskUrl.trim());
    } catch {
        return null;
    }

    if (!parsedUrl.href.includes("/project/") || !parsedUrl.href.includes("/s/")) return null;

    return {
        taskKey: taskLabel.slice(0, separatorIndex).trim(),
        taskName: taskLabel.slice(separatorIndex + 3).trim(),
        url: taskUrl.trim(),
    };
}

module.exports = {
    buildTaskShareMessage,
    parseTaskShareMessage,
};
